import path from 'path';
import fs from 'fs';
import { findProjectJsonFiles } from './nx-helpers';

export const getSrcRoot = async (cwd: string): Promise<string[]> => {
	const angularJsonPath = path.join(cwd, 'angular.json');
	if (fs.existsSync(angularJsonPath) && fs.statSync(angularJsonPath).isFile()) {
		const srcRoots: string[] = [];
		const angularJson = JSON.parse(fs.readFileSync(angularJsonPath, 'utf8'));
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const projects: Record<string, any> = angularJson.projects || {};
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		for (const [_, projectConfig] of Object.entries(projects)) {
			if (projectConfig.projectType === 'application') {
				srcRoots.push(projectConfig.sourceRoot);
			}
		}
		return srcRoots;
	}

	const nxJsonPath = path.join(cwd, 'nx.json');
	if (fs.existsSync(nxJsonPath) && fs.statSync(nxJsonPath).isFile()) {
		const projectJsonFiles = await findProjectJsonFiles(cwd);
		const srcRoots: string[] = [];
		for (const filePath of projectJsonFiles) {
			const projectJson = JSON.parse(fs.readFileSync(filePath, 'utf8'));
			const isProjectAngular =
				projectJson.projectType === 'application' &&
				(projectJson.targets?.build?.executor as string).includes('angular');

			if (!isProjectAngular) {
				continue;
			}

			srcRoots.push(path.join(cwd, projectJson.sourceRoot));
		}
		return srcRoots;
	}

	const srcRoot = path.join(cwd, 'src');
	if (fs.existsSync(srcRoot) && fs.statSync(srcRoot).isDirectory()) {
		return [srcRoot];
	}

	throw new Error('Could not find src root');
};
